import React from "react"

const ConditionalView = (props: { condition: boolean; children: any }) => {
  if (!props.children.length) return props.condition ? props.children : null
  return props.condition ? props.children[0] : props.children[1]
}

export default ConditionalView

ConditionalView.defaultProps = {}
